export default __webpack_public_path__ + "static/65285943-0-crushing-tough-cg-pl-dd4995280bb330b154beca09d5f0dda1.webp";